import store from 'src/store'

/**
 * This utility is to detect if the site is allow to bypassing site-controller's maintenance.
 *
 * https://concierge.qa.tripla.ai/tripla/feature_flags/44
 * @returns boolean
 */
export function allowBypassSiteMaintenance() {
  const currentUrl = new URL(window.location.href)
  return (
    store.getters['maintenance/getBypassSiteMaintenance'] ||
    currentUrl.searchParams.get('maintenance_mode') === 'false'
  )
}
